export var DocsBlockRichTextPropertyStyle;
(function (DocsBlockRichTextPropertyStyle) {
    /** Title type 1, roughly equivalent of h2 in size */
    DocsBlockRichTextPropertyStyle["title1"] = "Title1";
    /** Title type 2, roughly equivalent of h3 in size */
    DocsBlockRichTextPropertyStyle["title2"] = "Title2";
    /** Title type 3, roughly equivalent of h4 in size */
    DocsBlockRichTextPropertyStyle["title3"] = "Title3";
    /** Title type 4, roughly equivalent of h5 in size */
    DocsBlockRichTextPropertyStyle["title4"] = "Title4";
    /** Title type 5, roughly equivalent of h6 in size */
    DocsBlockRichTextPropertyStyle["title5"] = "Title5";
    /** Quote */
    DocsBlockRichTextPropertyStyle["quote"] = "Quote";
    /** Callout */
    DocsBlockRichTextPropertyStyle["callout"] = "Callout";
    /** Default option */
    DocsBlockRichTextPropertyStyle["default"] = "Default";
})(DocsBlockRichTextPropertyStyle || (DocsBlockRichTextPropertyStyle = {}));
